var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgQuestion = function SvgQuestion(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#5855F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.986 18.988v-.668q0-.784.18-1.366.18-.584.604-1.092.424-.519 1.145-1.08.741-.585 1.176-1.007.444-.424.635-.848.202-.435.202-1.006 0-.9-.615-1.367-.603-.477-1.706-.477-.974 0-1.833.275-.858.276-1.695.69l-.88-1.866a10 10 0 0 1 2.088-.848A9 9 0 0 1 15.777 8q2.16 0 3.338 1.049 1.185 1.05 1.186 2.766 0 .943-.296 1.62-.297.669-.88 1.24-.572.562-1.388 1.187-.668.53-1.028.922a2.3 2.3 0 0 0-.487.774 3 3 0 0 0-.127.943v.487zm-.403 3.412q0-.87.445-1.218.456-.36 1.113-.36.636 0 1.091.36.456.35.456 1.218 0 .848-.456 1.23-.455.37-1.091.37-.657 0-1.113-.37-.444-.383-.445-1.23"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgQuestion);
export { ForwardRef as ReactComponent };